import { useEffect, useRef } from 'react';
import { isLoggedIn } from '../components/authProvider/AuthContext';
import { startActivityTracking } from '../components/authProvider/tabSession';

// 15 minutes without activity in any tab logs the user out. Refreshing no
// longer logs out (the old beforeunload logout fired on every refresh); tab
// and browser close are handled in tabSession.js.
export const useAutoLogout = (onLogout) => {
  const onLogoutRef = useRef(onLogout);
  onLogoutRef.current = onLogout;

  useEffect(() => {
    if (!isLoggedIn()) return undefined;
    return startActivityTracking(() => onLogoutRef.current());
  }, []);
};
